import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import QRCode from 'react-qr-code';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const AttendanceWithQR = () => {
  const { code } = useParams();
  const [fetchData] = useFetch();

  const [profileData, setProfileData] = useState({
    name: '',
    think5whysCode: code,
    bloodGroup: '',
    institution: '',
    email: '',
    mobile: '',
    city: '',
    isAvailable: false,
    availableForWork: '',
  });

  const [loading, setLoading] = useState(true);

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: `/pub/blue/${code}`,
      method: 'get',
    };

    fetchData(config)
      .then(response => {
        if (response?.status && response.blueProfile) {
          const p = response.blueProfile;
          setProfileData({
            name: p.name,
            think5whysCode: p.think5whysCode,
            bloodGroup: p.bloodGroup,
            institution: p.institution,
            email: p.email,
            mobile: p.mobile,
            city: p.city,
            isAvailable: p.isAvailable,
            availableForWork: p.availableForWork,
          });
        }
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [code, fetchData]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  const origin = window.location.origin;
  const qrValue = `${origin}/pub/blue/${code}`;

  if (loading) return <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-yellow-200">Loading Profile...</div>;

  return (
    <div className="min-h-screen bg-zinc-950 text-gray-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-zinc-900 rounded-3xl overflow-hidden border border-yellow-500/30 shadow-2xl">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-cyan-600 p-6 text-center">
            <h1 className="text-2xl font-bold text-white">{profileData.name}</h1>
            <p className="text-blue-100 mt-1">{profileData.think5whysCode}</p>
          </div>

          <div className="p-8 space-y-6">
            {profileData.isAvailable && (
              <div className="bg-emerald-900/50 border border-emerald-500 rounded-2xl p-4 text-center">
                <p className="text-emerald-300 font-medium">✅ Available Now</p>
                <p className="text-emerald-400 text-sm mt-1">{profileData.availableForWork}</p>
              </div>
            )}

            <div className="space-y-3 text-sm">
              <p><span className="text-gray-400">Institution:</span> {profileData.institution}</p>
              <p><span className="text-gray-400">Blood Group:</span> {profileData.bloodGroup}</p>
              <p><span className="text-gray-400">City:</span> {profileData.city}</p>
            </div>

            {/* QR Code */}
            <div className="bg-black rounded-3xl p-8 flex flex-col items-center">
              <QRCode value={qrValue} size={220} className="bg-white p-4 rounded-2xl" />
              <p className="text-xs text-gray-400 mt-4 text-center break-all">{qrValue}</p>
            </div>

            {/* Quick Actions */}
            <div className="grid grid-cols-3 gap-4">
              <a href={`tel:${profileData.mobile}`} className="bg-zinc-800 hover:bg-zinc-700 rounded-2xl py-4 flex flex-col items-center gap-1">
                <FontAwesomeIcon icon={faPhone} className="text-xl" />
                <span className="text-xs">Call</span>
              </a>
              <a href={`mailto:${profileData.email}`} className="bg-zinc-800 hover:bg-zinc-700 rounded-2xl py-4 flex flex-col items-center gap-1">
                <FontAwesomeIcon icon={faEnvelope} className="text-xl" />
                <span className="text-xs">Email</span>
              </a>
              <a href={`https://wa.me/${profileData.mobile}`} target="_blank" className="bg-zinc-800 hover:bg-zinc-700 rounded-2xl py-4 flex flex-col items-center gap-1">
                <FontAwesomeIcon icon={faWhatsapp} className="text-xl" />
                <span className="text-xs">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-8">
          Powered by Think5Whys • Attendance QR Card
        </p>
      </div>
    </div>
  );
};

export default AttendanceWithQR;